import { lowerCase, startCase } from 'lodash';
import { BASE_PARAMS } from './constants';

export const createMixpanelEvent = (type) => ({
    collection = {},
    item = {},
    sourceInfo = {}
} = {}) => ({
    type,
    userId: sourceInfo.userId,
    'Page Name': startCase(sourceInfo.name),
    'Collection Name': collection.name,
    'Owner Type': lowerCase(collection.ownerType),
    'Resource Id': item.resourceId,
    'Resource Type': lowerCase(item.resourceType),
    ...BASE_PARAMS
});
